import { createTrendsFeed } from './stores.js';
import { derived } from 'svelte/store';

import {
  renderSvelteComponent,
  findElementByIdInShadowDom,
} from './utils/render.js';

import GovernorTrends from './components/GovernorTrends.svelte';

async function main() {
  const trendsFeed = await createTrendsFeed();

  const usGovernorTrends = derived(trendsFeed, ($feed) => {
    const governor = $feed.data?.attributes?.governor;

    if (!governor || typeof governor.total !== 'number') {
      throw new Error(
        'Trends response does not contain Governor data with a numeric total.'
      );
    }

    return governor;
  });

  const element = findElementByIdInShadowDom('trends-us-governor-viz');

  if (element) {
    renderSvelteComponent(GovernorTrends, element, {
      feed: usGovernorTrends,
    });
  }
}

main().catch(console.error);
